<style src="./CameraAgente.scss" lang="scss"></style>
<template>
  <section class="camera-agente">
    <form
      @submit.prevent="submitBridge"
      class="form"
      v-shortkey="['esc']"
      @shortkey="submitRemove(selectedPhoto.id)"
    >
      <button
        type="button"
        class="buttonremove"
        @click="submitRemove(selectedPhoto.id)"
        :disabled="disabled.remove"
      >
        Remover
      </button>
      <label>
        <span>Placa do Veículo</span>
        <input
          type="text"
          v-model="form.licencePlate"
          ref="inputLicencePlate"
        />
      </label>

      <button class="buttonaccept" :disabled="disabled.accept">
        Aceitar
      </button>

      <button type="button" class="buttonConfig" @click="toggleConfig">
        <i class="fa fa-gear"></i>
      </button>

      <section class="config" v-show="displayConfig">
        <label class="parkingSet">
          <span>Estacionamento</span>
          <select v-model="form.parking">
            <option
              v-for="(park, parkIdx) in parks"
              :key="parkIdx"
              :value="park.id"
            >
              {{ park.name }}
            </option>
          </select>
        </label>

        <label class="photoCount">
          <span>Qt fotos</span>
          <input type="text" v-model="form.countPhotos" />
        </label>
        <label class="refreshRate">
          <span>Taxa Att</span>
          <input type="text" v-model="form.refreshRate" />
        </label>
      </section>
    </form>

    <section class="mainphoto">
      <img
        class="stickedPhoto"
        :src="selectedPhoto.path"
        alt="foto grudada"
        :style="{
          'object-position': `${zoom.thumb.left}% ${zoom.thumb.top}%`,
        }"
        @click="stickPhoto(false)"
        ref="mainPhoto"
        v-if="showStickedPhoto"
      />
      <img
        class="photo"
        :src="selectedPhoto.path"
        alt="foto"
        @mousemove="mouseMove"
        @click="stickPhoto(true)"
        ref="mainPhoto"
        v-if="!showStickedPhoto"
      />
      <template v-if="!showStickedPhoto">
        <div
          class="mask"
          :style="{ left: `${zoom.mask.left}px`, top: `${zoom.mask.top}px` }"
        ></div>

        <img
          class="zoom"
          :src="selectedPhoto.path"
          alt="zoom"
          :style="{
            'object-position': `${zoom.thumb.left}% ${zoom.thumb.top}%`,
          }"
        />
      </template>
    </section>

    <section
      class="photolist"
      v-shortkey="{ right: ['arrowright'], left: ['arrowleft'] }"
      @shortkey="photoNavigation"
    >
      <div
        class="photos"
        :class="{ selected: selectedPhoto.id === photo.id }"
        v-for="(photo, photoIdx) in photos"
        :key="photoIdx"
      >
        <img :src="photo.path" @click="selectPhoto(photo, photoIdx)" />
      </div>
    </section>
  </section>
</template>

<script>
import { URI_VEHICLE_SCAN } from '@/config/config';

let refreshInterval = null;
const secondsToRemoveTempImage = 20; // Time to keep the image on temp list

export default {
  data: () => ({
    photos: [],
    removedPhotos: [],
    selectedPhoto: {
      id: null,
      path: '',
      idx: -1,
    },
    form: {
      licencePlate: '',
      parking: '',
      parkingCodeEmpro: '',
      countPhotos: 10,
      refreshRate: 5000, // Interval to list all images from server
      eraseRemovedPhotosInterval: 10000, // Interval to check the temp list and remove item
    },
    displayConfig: false,
    disabled: {
      removeButton: false,
      accept: false,
    },
    parks: [],
    zoom: {
      thumb: {
        left: 0,
        top: 0,
      },
      mask: {
        left: 0,
        top: 0,
      },
    },
    showStickedPhoto: false,
  }),
  mounted() {
    this.listAllParks();
    this.listAllPhotos();
    this.listAllOcrParks();
    refreshInterval = setInterval(
      () => this.listAllPhotos(),
      this.form.refreshRate,
    );
    setInterval(
      () => this.removeTempPhotos(),
      this.form.eraseRemovedPhotosInterval,
    );
  },
  watch: {
    'form.refreshRate'() {
      clearInterval(refreshInterval);
      if (this.form.refreshRate < 2000) {
        return;
      }
      this.form.eraseRemovedPhotosInterval =
        Number(this.form.refreshRate) + 10000;
      refreshInterval = setInterval(
        () => this.listAllPhotos(),
        this.form.refreshRate,
      );
    },
  },
  methods: {
    isEmproServer(parkingId) {
      const parkings = this.$store.state.OCR.parkings;
      const parkId = parkings.filter(p => p.id === parkingId);

      if (parkId.length > 0) {
        const isEmproServer = parkId[0].server && parkId[0].server === 'empro';
        this.form.parkingCodeEmpro = parkId[0].code;
        return !!isEmproServer;
      }
      return false;
    },
    getParkingCode(parkingId) {
      const parkings = this.$store.state.OCR.parkings;
      const parking = parkings.filter(p => p.id === parkingId);
      if (!(parking && parking.length > 0)) {
        return false;
      }

      return parking[0] && parking[0].code;
    },
    submitBridge() {
      const isEmproServer = this.isEmproServer(this.form.parking);
      if (isEmproServer) {
        this.submitAcceptEMPRO();
      } else {
        this.submitAccept();
      }
    },
    stickPhoto(showStick) {
      this.showStickedPhoto = showStick;
      this.$refs.inputLicencePlate.focus();
    },
    mouseMove(event) {
      const maskSize = 50;

      const mouseX = event.offsetX;
      const mouseY = event.offsetY;

      const maskLeftPos = mouseX - maskSize;
      const maskTopPos = mouseY - maskSize;

      this.zoom.mask.left = maskLeftPos;
      this.zoom.mask.top = maskTopPos;

      const imageWidth = this.$refs.mainPhoto.clientWidth;
      const imageHeight = this.$refs.mainPhoto.clientHeight;

      const thumbLeftPos = (100 * mouseX) / imageWidth;
      const thumbTopPos = (100 * mouseY) / imageHeight;

      this.zoom.thumb.left = thumbLeftPos;
      this.zoom.thumb.top = thumbTopPos;
    },
    photoNavigation({ srcKey }) {
      this.form.licencePlate = '';
      this.stickPhoto(false);
      if (srcKey === 'left') {
        let photoIdx = this.selectedPhoto.idx;
        if (photoIdx === 0) return;
        photoIdx -= 1;
        this.selectPhoto(this.photos[photoIdx], photoIdx);
      } else {
        let photoIdx = this.selectedPhoto.idx;
        if (photoIdx === this.photos.length - 1) return;
        photoIdx += 1;
        this.selectPhoto(this.photos[photoIdx], photoIdx);
      }
    },
    toggleConfig() {
      this.displayConfig = !this.displayConfig;
    },
    removeTempPhotos() {
      const now = new Date().getTime();
      const newRemovedPhotos = this.removedPhotos.filter(i => {
        return !(i.removeWhen <= now);
      });
      this.removedPhotos = newRemovedPhotos;
    },
    addDecimalDotOnGeolocation(value) {
      const cleanValue = value.replace('.jpg', '');
      const addSignal = `-${cleanValue}`;
      const addDot =
        addSignal.substring(0, 3) +
        '.' +
        addSignal.substring(3, addSignal.length);
      return addDot;
    },
    formatLicencePlate(value) {
      const upper = value.toUpperCase();
      const dash = upper.substring(0, 3) + '-' + upper.substring(3, 7);
      return dash;
    },
    formatDateBR(value) {
      const options = {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      };
      const dt = new Intl.DateTimeFormat('pt-BR').format(new Date(value));
      const tm = new Intl.DateTimeFormat('pt-BR', options).format(
        new Date(value),
      );
      return `${dt} ${tm}`;
    },
    async listAllOcrParks() {
      try {
        await this.$store.dispatch('OCR/ListEmproParkings');
      } catch (error) {
        console.error(error);
      }
    },
    async listAllParks() {
      const parkingListFull = await this.$store.dispatch('PARKING/GetParkList');
      const parks = parkingListFull.map(park => ({
        id: park._id,
        name: park.parkName,
      }));
      this.parks = parks;
    },
    async listAllPhotos() {
      if (this.photos.length === this.form.countPhotos) {
        return;
      }
      const opts = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const userLoginInfoResult = await fetch(
        `${URI_VEHICLE_SCAN}list-all-from-folder?countPhotos=${this.form.countPhotos}`,
        opts,
      );
      const photos = await userLoginInfoResult.json();
      const avoidPhotos = this.removedPhotos.map(i => i.id);

      const photoMapped = photos
        .filter(photo => avoidPhotos.indexOf(photo) === -1)
        .map(photo => {
          const [type, dateTimestamp, parking, lat, lng] = photo.split('-');
          const latitude = this.addDecimalDotOnGeolocation(lat);
          const longitude = this.addDecimalDotOnGeolocation(lng);

          return {
            id: photo,
            path: `${URI_VEHICLE_SCAN}ocr/${photo}`,
            dateTime: new Date(Number(dateTimestamp)),
            type,
            parking,
            latitude,
            longitude,
          };
        });
      this.photos = photoMapped;
      if (this.selectedPhoto.id === null && photoMapped.length > 0) {
        this.selectPhoto(photoMapped[0], 0);
      }
    },
    selectPhoto(photoMapped, photoIdx) {
      this.$refs.inputLicencePlate.focus();

      if (!this.photos.length) {
        this.parks = [];
        this.selectedPhoto = {
          id: null,
          path: '',
        };
        return false;
      }
      this.form.parking = photoMapped.parking;
      this.parks = [
        {
          id: photoMapped.parking,
          name: photoMapped.parking,
        },
      ];
      this.selectedPhoto = {
        ...photoMapped,
        idx: photoIdx,
      };
    },
    submitVehicles() {
      this.submitAccept();
      this.submitAcceptEMPRO();
    },
    addTempImage(photoId) {
      const timestampToRemove =
        new Date().getTime() + secondsToRemoveTempImage * 1000;
      this.removedPhotos.push({
        removeWhen: timestampToRemove,
        id: photoId,
      });
    },
    async submitAcceptEMPRO() {
      const hasLicencePlate =
        this.form.licencePlate && this.form.licencePlate.trim().length === 7;
      if (!hasLicencePlate) return;

      this.disabled.accept = true;
      const payload = {
        originalDate: this.selectedPhoto.dateTime,
        data: this.formatDateBR(this.selectedPhoto.dateTime),
        placa: this.formatLicencePlate(this.form.licencePlate),
        latitude: this.selectedPhoto.latitude,
        longitude: this.selectedPhoto.longitude,
        id_setor: this.form.parkingCodeEmpro,
        fileName: this.selectedPhoto.id,
      };

      // Reset form
      this.addTempImage(this.selectedPhoto.id);
      this.photos.splice(this.selectedPhoto.idx, 1);
      this.form.licencePlate = '';
      this.$refs.inputLicencePlate.focus();
      this.selectPhoto(this.photos[0], 0);

      const client = this.$store.getters['DATA-ACCESS/client'];
      const opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          clientid: client._id,
        },
        body: JSON.stringify(payload),
      };
      try {
        await fetch(`${URI_VEHICLE_SCAN}empro/licence-plate`, opts);
      } catch (error) {
        console.error(error);
      } finally {
        this.disabled.accept = false;
      }
    },
    async submitAccept() {
      if (
        !(this.form.licencePlate && this.form.licencePlate.trim().length > 5)
      ) {
        return;
      }
      const parkingCode = this.getParkingCode(this.form.parking);

      this.disabled.accept = true;
      const payload = {
        licencePlate: this.form.licencePlate.toLowerCase(),
        parkId: parkingCode,
        fileName: this.selectedPhoto.id,
      };

      const opts = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      };
      try {
        await fetch(`${URI_VEHICLE_SCAN}park`, opts);
        this.form.licencePlate = '';
        await this.listAllPhotos();
        this.selectFirstItem();
      } catch (error) {
        console.error(error);
      } finally {
        this.disabled.accept = false;
      }
    },
    async submitRemove(photoId, photoIdx) {
      this.addTempImage(photoId);
      this.photos.splice(photoIdx, 1);
      const URI = `${URI_VEHICLE_SCAN}remove-photo/${photoId}`;

      this.disabled.remove = true;
      const opts = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      try {
        await fetch(URI, opts);
        await this.listAllPhotos();
        this.selectFirstItem();
      } catch (error) {
        console.error(error);
      } finally {
        this.disabled.remove = false;
      }
    },
    selectFirstItem() {
      if (this.photos.length > 0) {
        const firstPhoto = this.photos[0];
        this.selectPhoto(firstPhoto, 0);
      } else {
        this.selectPhoto(false, false);
      }
    },
  },
};
</script>
